import React, { useEffect, useState } from "react";
import { Search } from "lucide-react";
import PaginationComp from "../../../common/ui/view/pagination/PaginationComp";
import { UserCertificate } from "../../../config/apiServices";
import { User_Certificate_Certificate } from "../../../config/adminUrlConfig";
import { useLocation } from "react-router-dom";

const Certificate = () => {
    const [currentpage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [search, setSearch] = useState("");
    const [data, setData] = useState([]);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const location = useLocation();
    const atomId = location.state?.atomId;

    useEffect(() => {
        if (!atomId) return;

        UserCertificate.get(`${User_Certificate_Certificate}/${atomId}?page=${currentpage}&limit=${recordsPerPage}`)
            .then((res) => {
                const responseData = res.data?.data || [];
                setData(Array.isArray(responseData) ? responseData : []);
                setTotalPages(res.data?.totalPages || 0);
            })
            .catch(() => {
                setData([]); 
                setTotalPages(0);
            });
    }, [atomId, currentpage, recordsPerPage]);

    const filteredData = data.filter((item) => {
        return item.eventName?.toLowerCase().includes(search.toLowerCase());
    });

    return (
        <div className="container-fluid pt-0">
            <div className="d-flex align-items-center mb-4 bg-white p-3 rounded shadow-sm">
                <h5 className="mb-0 fw-bold fs-5">
                    <span style={{ color: "#ff8ab3" }}>Digital Certificates & Accreditation</span>
                    <span className="text-muted fw-normal"> / Certificates</span>
                </h5>
            </div>

            <div className="card border-0 shadow-sm rounded-3">
                <div className="card-body p-4">
                    <div className="mb-4">
                        <div className="position-relative border rounded p-1">
                            <span className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted">
                                <Search size={18} />
                            </span>
                            <input
                                type="text"
                                className="form-control border-0 ps-5 shadow-none"
                                placeholder="Search Event name..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                style={{ height: "40px" }}
                            />
                        </div>
                    </div>

                    <div className="table-responsive rounded border">
                        <table className="table table-borderless align-middle mb-0">
                            <thead style={{ backgroundColor: "#8a61b8", color: "white" }}>
                                <tr>
                                    <th className="py-3 ps-4 rounded-top-start fw-bold fs-6">Event Name</th>
                                    <th className="py-3 text-center fw-bold fs-6">Date</th>
                                    <th className="py-3 pe-4 text-end rounded-top-end fw-bold fs-6">Action</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white">
                                {filteredData?.length > 0 ? (
                                    filteredData.map((item, i) => (
                                        <tr key={i} style={{ borderBottom: "1px solid #f0f0f0" }}>
                                            <td className="ps-4 py-3 fw-medium text-dark">{item.eventName}</td>
                                            <td className="py-3 text-center text-muted fw-medium">
                                                {new Date(item.createdAt).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
                                            </td>
                                            <td className="py-3 pe-4 text-end text-primary fw-bold" style={{ cursor: "pointer" }} onClick={() => window.open(item.link)}>
                                                Action
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="text-center py-5 bg-white border-top">
                                            <h6 className="mb-0 fw-bold text-dark fs-5">Data is not available</h6>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {totalPages > 0 && (
                        <div className="d-flex justify-content-center py-4 mt-2">
                            <PaginationComp
                                size={totalPages}
                                currentpage={currentpage}
                                setCurrentPage={setCurrentPage}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Certificate;